export enum DeviceMicStateV2 {
	Active = 'ACTIVE',
	Mute = 'MUTE',
	OnCharger = 'ON_CHARGER',
	Unknown = 'UNKNOWN'
}
